import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { ThemeService } from "../../../services/theme/theme.service";
import { LanguageService } from "../../../services/language/language.service";
import { UserService, User } from "../../../services/user.service";
import { AuthService } from "../../../services/auth/auth.service";
import { FrontendLoggerService } from "../../../services/frontend-logger.service";
import { CHANGE_DETECTION_FEATURE_CODE, DOC_GENERATION_FEATURE_CODE, KNOWLEDGE_ALERTS_FEATURE_CODE, KNOWLEDGE_HUB_FEATURE_CODE } from "../../../features/plans/models/entitlement.model";
import { PlanFeatureService } from "../../../features/plans/services/plan-feature.service";

@Component({
    selector: "app-sidebar",
    templateUrl: "./sidebar.component.html",
    styleUrls: ["./sidebar.component.scss"],
    standalone: false
})
export class SidebarComponent implements OnInit {
  @Output() toggleSidebar = new EventEmitter<void>();

  currentUser: User | null = null;
  isCollapsed = false;
  /** Gating por plan: la opción "Generar" solo se muestra si la feature doc_generation está habilitada. */
  docGenerationEnabled = false;
  /** R4: la sección "Conocimiento" solo se muestra si la feature knowledge_hub está habilitada. */
  knowledgeHubEnabled = false;
  /** R5: la opción "Cambios" solo se muestra si la feature change_detection está habilitada. */
  changeDetectionEnabled = false;
  /** R6: la opción "Alertas" solo se muestra si la feature knowledge_alerts está habilitada. */
  knowledgeAlertsEnabled = false;

  /**
   * Entrada unica "Knowledge Hub": visible si CUALQUIERA de las 4 features del hub
   * (doc_generation, knowledge_hub, change_detection, knowledge_alerts) esta activa.
   */
  get knowledgeHubMenuEnabled(): boolean {
    return (
      this.docGenerationEnabled ||
      this.knowledgeHubEnabled ||
      this.changeDetectionEnabled ||
      this.knowledgeAlertsEnabled
    );
  }

  constructor(
    public themeService: ThemeService,
    public languageService: LanguageService,
    private userService: UserService,
    private authService: AuthService,
    private frontendLogger: FrontendLoggerService,
    private planFeatureService: PlanFeatureService
  ) {}

  ngOnInit(): void {
    // Cargar usuario actual
    this.userService.getCurrentUser().subscribe({
      next: (user) => {
        this.currentUser = user;
      },
      error: (error) => {
        this.frontendLogger.error(`[SidebarComponent] Error al cargar el usuario: ${JSON.stringify(error)}`);
      },
    });

    // Gating por plan de la opción "Generar" (degrada a oculto si falla la consulta)
    this.planFeatureService.hasFeature(DOC_GENERATION_FEATURE_CODE).subscribe((enabled) => {
      this.docGenerationEnabled = enabled;
    });

    // Gating por plan de la sección "Conocimiento" (R4; degrada a oculto si falla la consulta)
    this.planFeatureService.hasFeature(KNOWLEDGE_HUB_FEATURE_CODE).subscribe((enabled) => {
      this.knowledgeHubEnabled = enabled;
    });

    // Gating por plan de la opción "Cambios" (R5; degrada a oculto si falla la consulta)
    this.planFeatureService.hasFeature(CHANGE_DETECTION_FEATURE_CODE).subscribe((enabled) => {
      this.changeDetectionEnabled = enabled;
    });

    // Gating por plan de la opción "Alertas" (R6; nace OFF, degrada a oculto si falla la consulta)
    this.planFeatureService.hasFeature(KNOWLEDGE_ALERTS_FEATURE_CODE).subscribe((enabled) => {
      this.knowledgeAlertsEnabled = enabled;
    });

    // Verificar estado de colapso guardado
    const savedState = localStorage.getItem("sidebar_collapsed");
    if (savedState) {
      this.isCollapsed = savedState === "true";
    }
  }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
    localStorage.setItem("sidebar_collapsed", this.isCollapsed.toString());
    this.toggleSidebar.emit();
  }

  translate(key: string): string {
    return this.languageService.translate(key);
  }

  // Verificar si el usuario tiene acceso al dashboard
  hasDashboardAccess(): boolean {
    // Mostrar dashboard para todos los usuarios
    return true;
  }

  logout(): void {
    this.authService.logout();
  }
}
